<template>
  <button @click="handleOnClickEvent" :class="getButtonClassName">
    <CustomIcon :class="iconClass" v-if="icon" :name="icon" /><slot></slot>
  </button>
</template>
<script>
import CustomIcon from "./CustomIcon.vue";
export default {
  name: "button-component",
  props: {
    variation: String,
    icon: String,
    size: String,
    iconPosition: String,
    iconClass: String,
    onClick: Function,
  },
  components: { CustomIcon },
  computed: {
    handleOnClickEvent() {
      if (this.onClick) {
        return this.onClick;
      }

      return () => null;
    },
    getButtonClassName() {
      let className = "button ";

      if (this.variation) {
        className += this.variation;
      }
      if (this.size) {
        className += this.size;
      }

      return className;
    },
  },
};
</script>
